export default "__VITE_PUBLIC_ASSET__769989f1__"